import React, { useState, useEffect } from 'react';
import { Cicle } from '../services/api';

interface CicleModalProps {
  isOpen: boolean;
  cicle: Cicle | null;
  onClose: () => void;
  onSave: (data: { nom: string; descripcio: string; actiu: boolean; nombre_cursos: number }) => void;
}

function CicleModal({ isOpen, cicle, onClose, onSave }: CicleModalProps) {
  const [nom, setNom] = useState('');
  const [descripcio, setDescripcio] = useState('');
  const [nombreCursos, setNombreCursos] = useState('2');
  const [actiu, setActiu] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      if (cicle) {
        setNom(cicle.nom);
        setDescripcio(cicle.descripcio);
        setNombreCursos(String(cicle.nombre_cursos || 2));
        setActiu(cicle.actiu);
      } else {
        setNom('');
        setDescripcio('');
        setNombreCursos('2');
        setActiu(true);
      }
      setError('');
    }
  }, [isOpen, cicle]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!nom.trim() || !descripcio.trim()) {
      setError('Tots els camps són obligatoris');
      return;
    }

    const nombreCursosNum = parseInt(nombreCursos);
    if (isNaN(nombreCursosNum) || nombreCursosNum <= 0) {
      setError('El nombre de cursos ha de ser superior a 0');
      return;
    }

    onSave({ nom: nom.trim(), descripcio: descripcio.trim(), actiu, nombre_cursos: nombreCursosNum });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{cicle ? 'Editar Cicle Formatiu' : 'Nou Cicle Formatiu'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nom">Nom del cicle</label>
            <input
              id="nom"
              type="text"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder="Ex: DAW, DAM, ASIX..."
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="descripcio">Descripció</label>
            <textarea
              id="descripcio"
              value={descripcio}
              onChange={(e) => setDescripcio(e.target.value)}
              placeholder="Descripció del cicle formatiu..."
            />
          </div>
          <div className="form-group">
            <label htmlFor="nombre-cursos">Nombre de cursos</label>
            <input
              id="nombre-cursos"
              type="number"
              value={nombreCursos}
              onChange={(e) => setNombreCursos(e.target.value)}
              min="1"
            />
          </div>
          <div className="form-group checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={actiu}
                onChange={(e) => setActiu(e.target.checked)}
              />
              <span className="checkbox-custom"></span>
              Cicle actiu
            </label>
          </div>
          {error && (
            <p style={{ color: 'var(--color-danger)', fontSize: '0.9rem' }}>{error}</p>
          )}
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel·lar
            </button>
            <button type="submit" className="btn btn-primary">
              {cicle ? 'Guardar canvis' : 'Crear cicle'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CicleModal;
